// 道路“车辆”环绕（矩形闭合曲线 + 切线朝向）
import * as THREE from 'three'

export function createTraffic(scene, boundsSource, {
  cars = 8,
  pad = 8,                   // 轨道离建筑的外扩距离
  y = 0.15,
  speed = { min: 0.9, max: 1.6 } // 车速（单位/秒）
} = {}) {
  const group = new THREE.Group()
  group.name = 'TrafficGroup'
  scene.add(group)

  // 基于 ddModel 包围盒生成闭合路径
  const box = new THREE.Box3().setFromObject(boundsSource)
  const pts = [
    new THREE.Vector3(box.min.x - pad, y, box.min.z - pad),
    new THREE.Vector3(box.max.x + pad, y, box.min.z - pad),
    new THREE.Vector3(box.max.x + pad, y, box.max.z + pad),
    new THREE.Vector3(box.min.x - pad, y, box.max.z + pad),
  ]
  const curve = new THREE.CatmullRomCurve3(pts, true, 'catmullrom', 0.1)

  const carsArr = []
  const body = new THREE.BoxGeometry(1.2, 0.4, 0.6)

  for (let i = 0; i < cars; i++) {
    const mat = new THREE.MeshStandardMaterial({
      color: new THREE.Color().setHSL(Math.random(), 0.35, 0.55),
      roughness: 0.75, metalness: 0.1
    })
    const car = new THREE.Mesh(body, mat)
    car.castShadow = false; car.receiveShadow = false
    car.userData.u = Math.random() // 曲线进度 0~1
    car.userData.speed = THREE.MathUtils.lerp(speed.min, speed.max, Math.random()) / curve.getLength() // 转为“每秒占比”
    const s = 0.8 + Math.random() * 0.5; car.scale.set(s, s, s)
    group.add(car); carsArr.push(car)
  }

  const tangent = new THREE.Vector3()
  const up = new THREE.Vector3(0, 1, 0)
  const m = new THREE.Matrix4()
  const q = new THREE.Quaternion()

  function update(delta) {
    let moved = false
    for (const car of carsArr) {
      car.userData.u = (car.userData.u + car.userData.speed * delta) % 1
      const pos = curve.getPointAt(car.userData.u)
      const nxt = curve.getPointAt((car.userData.u + 0.01) % 1)
      tangent.subVectors(nxt, pos).normalize()
      q.setFromUnitVectors(new THREE.Vector3(0, 0, 1), tangent)
      m.compose(pos, q, car.scale)
      car.matrixAutoUpdate = false
      car.matrix.copy(m)
      moved = true
    }
    return moved
  }

  function dispose() {
    scene.remove(group)
    group.traverse(o => { o.geometry?.dispose?.(); o.material?.dispose?.() })
  }

  return { group, update, dispose }
}
